export default __webpack_public_path__ + "static/media/blueprint of a broken home.b0f048cd.jpg";